export const TRACKING_CONSTANTS = {
  EVENTS: {
    VIEWGA4: 'page_view',
  },
  GA4: {
    LANGUAGE: {
      FR: 'fr',
    },
    PAGE: {
      TITLE: 'av_pagetitle',
      URL: 'av_url_path',
      CATEGORY: 'av_category',
      ENV: 'av_environment',
      ERROR: 'av_error_code',
      LANGUAGE: 'av_language',
      PLATFORM: 'av_platform',
      SITE: 'av_site',
      USER: 'av_user',
    },
    PLATFORM: {
      WEB: 'web',
    },
    USER: {
      UID: 'uid',
      STATUS: 'status',
    },
    CATEGORY: {
      financial_homepage: 'pro_account',
      financial_invoices: 'pro_account',
      financial_account_statement: 'pro_account',
      financial_payment_means: 'pro_account',
      financial_sepa_signature: 'pro_account',
      financial_sepa_signature_confirmation: 'pro_account',
      financial_billing_contact_information: 'pro_account',

    },
    PAGENAME: {
      financial_homepage: 'financial_homepage',
      financial_invoices: 'financial_invoices',
      financial_account_statement: 'financial_account_statement',
      financial_payment_means: 'financial_payment_means',
      financial_sepa_signature: 'financial_sepa_signature',
      financial_sepa_signature_confirmation: 'financial_sepa_signature_confirmation',
      financial_billing_contact_information: 'financial_billing_contact_information',
    }
  },
};
